import { Link } from 'react-router-dom';
import Icon from './Icon';
import Logo from './Logo';
import { FOOTER_LINKS, POLICY_LINKS } from '../constants/content';
import {
  ADDRESS_LINE1,
  ADDRESS_LINE2,
  COMPANY_NAME,
  SALES_EMAIL,
  SITE_DOMAIN,
  SITE_NAME,
  SUPPORT_EMAIL,
  SUPPORT_PHONE_LABEL,
  SUPPORT_PHONE_TEL,
} from '../constants/site';
import { openZohoChat } from '../utils/openZohoChat';

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="shell site-footer__grid">
        <div className="site-footer__brand">
          <Logo />
          <p>
            Certified bookkeeping experts for accounting software errors, company file repair
            and genuine licences — helping small businesses and their accountants every day.
          </p>
          <div className="site-footer__brand-actions">
            <a href={SUPPORT_PHONE_TEL} className="btn btn--green">
              <Icon name="phone" size={18} />
              {SUPPORT_PHONE_LABEL}
            </a>
            <button type="button" className="btn btn--green-line" onClick={openZohoChat}>
              <Icon name="chat" size={18} />
              Live Chat
            </button>
          </div>
        </div>

        <nav className="site-footer__col" aria-label="Company">
          <h3>Company</h3>
          <ul>
            {FOOTER_LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav className="site-footer__col" aria-label="Policies">
          <h3>Policies</h3>
          <ul>
            {POLICY_LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </nav>

        <div className="site-footer__col">
          <h3>Contact info</h3>
          <ul className="site-footer__contact">
            <li>
              <Icon name="phone" size={16} />
              <a href={SUPPORT_PHONE_TEL}>{SUPPORT_PHONE_LABEL}</a>
            </li>
            <li>
              <Icon name="mail" size={16} />
              <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
            </li>
            <li>
              <Icon name="cart" size={16} />
              <a href={`mailto:${SALES_EMAIL}`}>{SALES_EMAIL}</a>
            </li>
            <li>
              <Icon name="pin" size={16} />
              <span>
                {ADDRESS_LINE1}
                <br />
                {ADDRESS_LINE2}
              </span>
            </li>
          </ul>

          <div className="support-card">
            <Icon name="headset" size={20} />
            <div>
              <small>Expert help 24/7</small>
              <a href={SUPPORT_PHONE_TEL}>{SUPPORT_PHONE_LABEL}</a>
            </div>
          </div>
        </div>
      </div>

      <div className="shell site-footer__disclaimer">
        <h4>Disclaimer</h4>
        <p>
          {COMPANY_NAME} operates {SITE_NAME} at {SITE_DOMAIN} as an independent accounting
          and technical support service. We are not affiliated with or endorsed by any
          accounting software publisher. Product names used on this site are descriptive only
          and do not imply endorsement by any third-party brand owner. All third-party
          trademarks belong to their respective owners. Licences sold through this site are
          publisher-issued and covered by the publisher&apos;s money-back terms under their own
          end user licence agreement. Read the full <Link to="/disclaimer">disclaimer</Link>.
        </p>
      </div>

      <div className="shell site-footer__bar">
        <span>
          © {year} {COMPANY_NAME} · {SITE_DOMAIN}
        </span>
        <span className="site-footer__pay">
          <i>VISA</i>
          <i>MC</i>
          <i>AMEX</i>
          <i>PayPal</i>
        </span>
      </div>
    </footer>
  );
}
